<template>
  <div>
    <!-- 添加备注弹框 -->
    <el-dialog
      v-if="flags != 1"
      :visible.sync="exportVisible"
      title="添加备注"
      width="400px"
      :before-close="handleDialogClose1"
      :close-on-click-modal="false"
    >
      <el-form ref="exportForm" :model="exportForm" label-width="85px" label-position="left">
        <el-form-item label="添加备注：">
          <el-input
            type="textarea"
            v-model="exportForm.remark"
            maxlength="20"
            show-word-limit
            rows="3"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="handleDialogClose1">取消</el-button>
        <el-button size="small" type="primary" @click="checkRecord1">生成报表</el-button>
      </span>
    </el-dialog>
    <!-- 生成报表中 -->
    <el-dialog
      :visible.sync="createStatement"
      custom-class="base-dialog"
      width="30%"
      title="提示"
      :before-close="handleDialogClose"
    >
      <div class="create">
        <div style="text-align: center; margin-top: 20px">
          <img src="@/assets/images/finish.png" alt="" class="size" />
        </div>
        <!-- <div class="generating">报表生成中...</div> -->
        <div class="color">生成完成后，在后台管理-导出管理下载报表</div>
      </div>
      <div class="dialog-btn">
        <el-button size="small" @click="handleDialogClose">关闭</el-button>
        <el-button size="small" type="primary" @click="checkRecord">查看记录</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "generate_report",
  props: {
    control: {
      type: Boolean,
      default: false,
    },
    flags: null,
    biFlag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      exportVisible: false, //添加备注
      createStatement: false,
      exportForm: {
        //备注
        remark: "",
      },
    };
  },
  created() {},
  computed: {},
  mounted: function () {
    this.exportVisible = this.control;
    if (this.flags == 1) {
      this.createStatement = this.control;
    }
  },
  methods: {
    handleDialogClose() {
      this.$emit("transData", false);
    },
    //查看记录
    checkRecord() {
      // this.$store.dispatch('setActiveTopMenu', '2000039')
      window.open(`${window.location.origin}/bi-web/yunzhou-common/system-redirect?redirectUrl=${encodeURIComponent('/exportManagement?type=3')}`, "_blank");
      // this.$router.push({
      //   name: 'export'
      // })
    },
    //添加备注关闭弹框
    handleDialogClose1() {
      this.exportVisible = false;
      this.$emit("transData", false);
    },
    //效果导出
    checkRecord1() {
      this.$emit("transData1", this.exportForm.remark);
      if (this.biFlag) {
        this.createStatement = true;
      }
    },
    // 显示导出成功弹窗
    showSuccessDailog() {
      this.createStatement = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.create {
  width: 100%;
  text-align: center;
  .size {
    width: 140px;
    height: 160px;
  }

  .el-icon-check {
    font-size: 26px;
    color: #fe4d45;
    font-weight: 700;
  }
  .generating {
    font-size: 20px;
    font-weight: 700;
    color: #fe4d45;
    margin: 20px 0 10px 0;
  }
  .color {
    color: #666;
  }
}
</style>
